import {
  Integration,
  INTEGRATION_CATEGORY_TO_MERGE_CATEGORY,
  INTEGRATION_TO_MERGE_INTEGRATION_SLUG,
  IntegrationCategory,
  isMergeIntegration
} from '@kindo/universal';
import { useState } from 'react';

import { AvailableIntegrationWithDisplayName } from '../components/SettingsModal/IntegrationSettings/IntegrationSettings.types';

import {
  ToastType,
  useMergeIntegrationPopUp,
  useSlackIntegrationConnect,
  useToast
} from '~/hooks';
import { nextTrpc } from '~/trpc';

const useIntegrationConnect = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [refresh, setRefresh] = useState(false);
  const { enqueueToast } = useToast();

  const { openMergePopUp } = useMergeIntegrationPopUp({
    setRefresh,
    onSuccess: onSuccess ? onSuccess : () => {}
  });
  const { openSlack } = useSlackIntegrationConnect();

  const { data: integrationSecurityConfigs } =
    nextTrpc.adminSecurityConfig.listOrgIntegrationSecurityConfigs.useQuery();

  const orgIntegrationSecurityConfigs = integrationSecurityConfigs?.items ?? [];

  const connect = (integration: AvailableIntegrationWithDisplayName) => {
    const integrationConfig = orgIntegrationSecurityConfigs.find(
      (integrationConfig) =>
        integrationConfig.integration === integration.integrationName
    );

    if (!integrationConfig || !integrationConfig.accessEnabled) {
      enqueueToast({
        message: 'Integration disabled by your organization.',
        type: ToastType.ERROR
      });
      return null;
    }

    if (isMergeIntegration(integration.integrationName)) {
      if (integration.integrationCategory === IntegrationCategory.OTHER)
        return null;
      return openMergePopUp(
        INTEGRATION_CATEGORY_TO_MERGE_CATEGORY[integration.integrationCategory],
        INTEGRATION_TO_MERGE_INTEGRATION_SLUG[integration.integrationName]
      );
    }

    if (integration.integrationName === Integration.SLACK) {
      return openSlack();
    }

    console.error('Unknown category:', integration);
    return null;
  };

  return { connect, refresh };
};

export default useIntegrationConnect;
